import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

export enum DocuwareReportingFields {
	id = 'id',
	invoiceId = 'invoiceId',
	userId = 'userId',
	updateDate = 'updateDate',
	changes = 'changes',
	invoiceNumber = 'invoiceNumber',
	invoiceDate = 'invoiceDate',
	name = 'name',
	status = 'status'
}

export enum DocuwareReportingFilterFields {
	fromDate = 'fromDate',
	toDate = 'toDate',
	userId = 'userId'
}

export enum DocuwareReportingSearchSuggestionFields {
	invoiceNumber = 'invoiceNumber'
}

export declare namespace DocuwareReporting {
	interface Basic {
		[DocuwareReportingFields.id]: number
		[DocuwareReportingFields.invoiceId]: number
		[DocuwareReportingFields.userId]: number
		[DocuwareReportingFields.updateDate]: BasicString
		[DocuwareReportingFields.changes]: string[]
		[DocuwareReportingFields.invoiceNumber]: BasicString
		[DocuwareReportingFields.invoiceDate]: BasicString
		[DocuwareReportingFields.name]: BasicString
		[DocuwareReportingFields.status]: Entity
	}

	namespace Search {
		interface Result {
			[DocuwareReportingSearchSuggestionFields.invoiceNumber]: string[]
		}

		interface Config {
			[DocuwareReportingSearchSuggestionFields.invoiceNumber]: ConfigItem<DocuwareReportingSearchSuggestionFields>
		}
	}

	namespace Filters {
		interface Config {
			[DocuwareReportingFilterFields.fromDate]: ConfigFilterItem<string, null>
			[DocuwareReportingFilterFields.toDate]: ConfigFilterItem<string, null>
			[DocuwareReportingFilterFields.userId]: ConfigFilterItem<string, string>
		}
	}
}
